import { defineStyleConfig } from "@chakra-ui/react";

export const switchTheme = defineStyleConfig({
	defaultProps: {
		colorScheme: "green",
	},
});
